import React from "react";
import ReactMarkdown from "react-markdown";
import privacyPolicyContent from "./PrivacyPolicy.md";
import "./index.css";

const PrivacyPolicy = () => {
  const [markdownContent, setMarkdownContent] = React.useState("");

  React.useEffect(() => {
    fetch(privacyPolicyContent)
      .then((response) => response.text())
      .then((text) => setMarkdownContent(text));
  }, []);

  return (
    <div className="container mx-auto px-4">
      <div className="body">
        <ReactMarkdown className="markdown-body">
          {markdownContent}
        </ReactMarkdown>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
